import React from 'react';

function Last() {
  return (
         <footer>
            <div className="container">
            <p data-aos="flip-left text-succes">&copy; МАНГАА TEAM.</p>
            <ul className="list-inline">
                <li className="list-inline-item">
                <a href="#">2020</a>
                </li>
                <li className="list-inline-item">
                <a href="#">МАНГАА</a>
                </li>
                <li className="list-inline-item">
                <a href="#">TEAM</a>
                </li>
            </ul>
            </div>
        </footer>
  );
}

export default Last;
